const REFRESH_TOKEN_PATH = '/token/refresh';

export const isRefreshTokenUrl = (url: string): boolean => {
    return !!url && url.substring(url.length - REFRESH_TOKEN_PATH.length) === REFRESH_TOKEN_PATH;
};
